import { Component } from "react";
import { createPortal } from "react-dom";

const isClient = !!(typeof window !== "undefined" && window.document && window.document.createElement);

interface PortalProps {
  node?: Element;
  className?: string;
  children: React.ReactNode;
}

export default class Portal extends Component<PortalProps> {
  node: HTMLDivElement | null = null;
  componentWillUnmount() {
    if (this.node) {
      document.body.removeChild(this.node);
    }
    this.node = null;
  }

  render() {
    const { node: propsNode, children, className } = this.props;

    if (!isClient) {
      return null;
    }

    if (!propsNode && !this.node) {
      this.node = document.createElement("div");
      this.node.className = className || "";
      document.body.appendChild(this.node);
    }

    return createPortal(children, (propsNode || this.node) as Element);
  }
}
